
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GAService from '@/services/ga.service';
import { Bucket } from '@/store/types';
import _ from 'lodash';

@Component({
  components: {
  },
})
export default class SelectBucketingModal extends Vue {

  public internalSelectedBucketing: string = '';
  public internalCustomSelectedBucketing: string = '';
  public modalScreenShowing: 'select' | 'new' = 'select';
  public typeOfBucketSelected: 'custom' | 'regulatory' = 'regulatory';

  public MAX_DIVIDERS: number = 12;
  public customBucketName: string = '';
  public bucketDividers: string[] = ['0'];
  public bucketDividersError: string = '';
  public customBucketNameError: string = '';

  public get attributeIdUnderEdit(): string | undefined {
    return this.$store.getters.getAttributeIdUnderEdit;
  }

  public get optionsData() {
    return this.$store.state.options.options || {};
  }

  get customBuckets() {
    if (this.$store.state.buckets.customBuckets) {
      return _.orderBy(this.$store.state.buckets.customBuckets, ['id'], ['desc']);
    }

    return [];
  }

  get activeBucket(): Bucket {
    return this.$store.getters.getBucketingForAttribute(this.attributeIdUnderEdit);
  }

  get isSavedDisabled() {
    if (!this.internalSelectedBucketing) {
      return true;
    } else if (this.modalScreenShowing === 'new') {
      return !!this.bucketDividersError;
    }
    return false;
  }

  @Watch('bucketDividers')
  private onBucketDividersChange(value: string[], oldValue: string[]) {
    let error = '';
    let lastNumber: number = 0;
    for (let i = 0; i < value.length; i++) {
      if (!this.isNumeric(value[i])) {
        error = 'Bucket divider values must be numeric';
        break;
      } else {
        const numeric = parseFloat(value[i]);
        if (i > 0) {
          if (numeric <= lastNumber) {
            error = 'Bucket divider values must increase';
            break;
          }
        }
        lastNumber = numeric;
      }
    }
    this.bucketDividersError = error;
  }

  @Watch('customBucketName')
  private onCustomBucketNameChange(value: string, oldValue: string) {
    if (!!value) {
      this.customBucketNameError = '';
    }
  }

  public selectBucket(typeOfBucket: 'custom' | 'regulatory', id: string) {
    this.typeOfBucketSelected = typeOfBucket;
    if (typeOfBucket === 'custom') {
      this.internalCustomSelectedBucketing = id;
    } else {
      this.internalSelectedBucketing = id;
    }
  }

  public isNumeric(value: any): boolean {
    return !isNaN(value - parseFloat(value));
  }

  public closeModal() {
    this.$store.commit('setModal', '');
  }

  public save() {
    let bucket: Bucket;
    const setBucketing = (): void => {
      this.$store.commit('setSelectedBucketing', { id: this.attributeIdUnderEdit, bucket });
    };

    if (this.modalScreenShowing === 'new') {
      if (!this.customBucketName) {
        this.customBucketNameError = 'You must name your custom bucket';
        return;
      }

      bucket = {
        type: 'custom',
        id: Date.now().toString(),
        name: this.customBucketName,
        value: this.bucketDividers.map( (str: string) => parseFloat(str))
      };
      this.$store.dispatch('saveCustomBucket', bucket);
      GAService.sendEvent(this.$gtag, 'Bucket', 'Custom Created', bucket.name as string);
      setBucketing();
    } else if (this.typeOfBucketSelected === 'regulatory') { // TODO: differentiate between custom and regulatory
      bucket = {
        type: 'regulatory',
        id: this.internalSelectedBucketing,
        value: this.optionsData.default_bucketing_sets[this.internalSelectedBucketing]
      };
      GAService.sendEvent(this.$gtag, 'Bucket', 'Regulatory Selected', this.internalSelectedBucketing);
      setBucketing();
    } else if (this.typeOfBucketSelected === 'custom') {
      bucket = this.customBuckets.find( (custBucket: any) => {
        return this.internalCustomSelectedBucketing === custBucket.id;
      }) || {};

      GAService.sendEvent(this.$gtag, 'Bucket', 'Custom Selected', bucket.name as string);
      setBucketing();
    }

    this.$store.commit('setAttributeIdUnderEdit', undefined);
    this.closeModal();
  }

  public toggleCustomBucketingView() {
    this.modalScreenShowing = this.modalScreenShowing === 'new' ? 'select' : 'new';
    // GAService.sendEvent(this.$gtag, 'Bucket', 'Window Toggled', this.customBucketingView ? 'Custom' : 'Main'); // TODO: look at
  }

  public addBucketDivider() {
    if (this.bucketDividers.length < this.MAX_DIVIDERS) {
      //this.internalCustomSelectedBucketing = 'new';
      const newNumber = parseFloat(this.bucketDividers[this.bucketDividers.length - 1]) + 1 + '';
      this.bucketDividers = this.bucketDividers.concat(newNumber);
    }
  }

  public removeDividerAtIndex(index: number) {
    if (this.bucketDividers.length > 1) {
      const arr = this.bucketDividers.slice();
      arr.splice(index, 1);
      this.bucketDividers = arr;
    } else {
      this.bucketDividers = ['0'];
    }
  }

  public newCustomBucketInputFocuessed() {
    //this.internalCustomSelectedBucketing = 'new';
  }

  public mounted() {
    GAService.sendEvent(this.$gtag, 'Bucket', 'Window Opened', 'Main');

    if (this.activeBucket && !_.isEmpty(this.activeBucket)) {
      if (this.activeBucket.type === 'regulatory') {
        this.typeOfBucketSelected = 'regulatory';
        this.internalSelectedBucketing = this.activeBucket.id;
      } else {
        this.typeOfBucketSelected = 'custom';
        this.internalSelectedBucketing = 'custom';
      }

      if (this.activeBucket.type === 'custom') {
        this.internalCustomSelectedBucketing = this.activeBucket.id;
      }
    } else {
      this.$store.commit('setToastError', 'Error: Failed to find bucket for editing');
      this.closeModal();
    }
  }
}

